import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Plate} from '../models/plate';
import {MaPlatePreparationService} from '../ma-plate-preparation/ma-plate-preparation.service';
import {MessagesService} from '../messages/messages.service';
import {Step} from '../models/step';
import {ErrorHandler} from '../utils/error-handler';
import {MasterDataService} from '../masterdata/masterdata.service';
import {WorkFlow} from '../masterdata/models/workFlow';
import {ProcessStepStage} from '../models/process-step-stages';
import {StepAction} from '../models/step-action';
import {BeadChipProcessStep, BeadChipStatus, PlateStatus, ProcessUpdateStage} from '../models/process-step';
import {BeadChipAction} from '../models/action';
import {Machine} from '../masterdata/models/machine';
import {BeadChipProcessFlows} from '../models/process-flows';
import {LoadBeadchipAxiom384} from '../models/load-beadchip';
import {saveAs as saveByFileSaver} from "file-saver";
import {
  Axiom384PlateMeta,
  BeadChipUpdateInfo,
  MultiBeadChipUpdate,
  WashAndStainArraysListDTO,
  WashAndStainPrepRequestDTO,
  WashAndStainPrepUpdateDTO
} from './multiplate-update-dto';
import {MaStorageService} from '../ma-storage/ma-storage.service';
import {CreateNewArraysDTO} from '../ma-result-evaluation/model/ma-result-evaluation-dtos';
import {MaResultEvaluationService} from '../ma-result-evaluation/ma-result-evaluation.service';
import {ProcessFlow} from '../masterdata/models/processFlow';
import {ProcessUpdateDTO, SampleData} from '../models/wb-process-update';
import {AnnouncedService} from '../apg-announced/services/announced.service';
import {Sample} from '../models/sample';

const BEADCHIP_COMPLETED_STATUSES = [BeadChipStatus.GENE_TITAN_LOADED, BeadChipStatus.COMPLETED]
const WASH_AND_STAIN_PREP_ACTIONS = [BeadChipAction.WASH_AND_STAIN_PREP, BeadChipAction.STABILIZATION, BeadChipAction.STAIN1, BeadChipAction.STAIN2, BeadChipAction.LIGATION, BeadChipAction.HOLD_BUFFER]
const WASH_AND_STAIN_PREP_ACTIONS_WITH_VARIABLE_NAMES = {
  "STABILIZATION":"stabilization",
  "STAIN1":"stain1",
  "STAIN2":"stain2",
  "LIGATION":"ligation",
  "HOLD_BUFFER":"holdBuffer",
}
const WASH_AND_STAIN_PREP_ACTIONS_WITH_CHEMICAL_NAMES = {
  "STABILIZATION":"Stabilization",
  "STAIN1":"Stain1",
  "STAIN2":"Stain2",
  "LIGATION":"Ligation",
  "HOLD_BUFFER":"Hold Buffer",
}

@Component({
  selector: 'app-ma-beadchip-loading-axiom',
  templateUrl: './ma-beadchip-loading-axiom.component.html',
  styleUrls: ['./ma-beadchip-loading-axiom.component.css']
})
export class MaBeadchipLoadingAxiomComponent implements OnInit {

  errorHandler: ErrorHandler = new ErrorHandler;
  blocked = false;
  selectedLabId: string;
  workFlowData: WorkFlow[] = [];
  workFlowMap: Map<string, WorkFlow> = new Map();
  puid: string;

  @Input() multiBeadChip: boolean;
  @Input() selectedBeadChipPlate: Plate;
  @Input() selectedBeadChipStepsMap: Map<string, Step>;
  @Input() selectedWorkFlow: WorkFlow;
  @Input() axiom384Plate1: Plate;
  @Input() axiom384PlateID1;
  @Input() selectedProcessFlowConfig: ProcessFlow;
  @Output() updateBeadChipDataEmitter = new EventEmitter<any>();
  @Output() reloadTableEmitter = new EventEmitter();
  @Output() plateViewResetEmitter = new EventEmitter();

  mapOfStatusSaves = new Map();
  mapOfProcessStepsFlow : Map<string, string[]> = new Map();
  mapOfProcessStepAndAction : Map<string, string[]> = new Map();
  mapOfActionRuntime : Map<string, number> = new Map();
  machinesList: Machine[];
  machinesBarcodeMap: Map<string, Machine> = new Map();

  // Axiom 384 Beadchip Loading Variables
  loadBeadChipLiquidHandler: string = "";
  load384BeadChipLiquidHandler: string = "";
  load384BeadChipChemicals: any[] = [];
  axiom384Beadchip = ""
  axiom384PlateID2 = ""
  axiom384Plate2: Plate = new Plate();
  axiom384PlateID3 = ""
  axiom384Plate3: Plate = new Plate();
  axiom384PlateID4 = ""
  axiom384Plate4: Plate = new Plate();

  // Multi Update Pop Up Variables
  multiUpdateBeadChipList: Array<any>;
  multiUpdateBeadChipInfoList: Array<any>;
  enteredBeadChipId: string;
  fetchedBeadChipPlate: Plate;
  multiUpdateProcessStepsMap :Map<string, Step>;
  multiBeadChipStepsMap: Map<string, Step>;
  multiStage: number;
  multiStepName: string;
  multiActionName: string;
  multiActionPos: number;
  multiUpdateStatus : string;
  mapOfStatusAndLabel = new Map();
  lastUpdatedBeadChips1: any[] = []
  lastUpdatedBeadChips2: any[] = []
  lastUpdatedBeadChips3: any[] = []
  showMultipleCommentDialog = false;
  lastUpdatedStatus: string;
  popUpWithDifferentMachine: boolean = false;
  processStepStartTime: string;
  multiLiquidHandler: string = "";
  washAndStainPopUp: boolean = false;
  washStainPrepEligibleArrays: Array<WashAndStainArraysListDTO> = []
  washAndStainTableSelectedRows : Array<WashAndStainArraysListDTO> = [];
  multiDestaticStainsCheckboxValue: boolean = false;
  multiPrepareStainsCheckboxValue: boolean = false;
  stabilizationEquipment: string = "";
  stabilizationChemical: string = "";
  stabilizationChemicalList: Array<string> = [];
  stain1Equipment: string = "";
  stain1Chemical: string = "";
  stain1ChemicalList: Array<string> = [];
  stain2Equipment: string = "";
  stain2Chemical: string = "";
  stain2ChemicalList: Array<string> = [];
  ligationEquipment: string = "";
  ligationChemical: string = "";
  ligationChemicalList: Array<string> = [];
  holdBufferEquipment: string = "";
  holdBufferChemical: string = "";
  holdBufferChemicalList: Array<string> = [];

  popUpWithDifferentMachineAndChemicals: boolean = false;
  washAChemical: string = "";
  washAChemicalList: Array<string> = [];
  washBChemical: string = "";
  washBChemicalList: Array<string> = [];
  axiomWaterChemical: string = "";
  axiomWaterChemicalList: Array<string> = [];
  weatherbySampleDataList : Array<SampleData> = []

  // Chemical Pop Up Variables
  noChemicalEdit : boolean;
  multiChemicalEdit: boolean;
  showDialogue= false;
  chemicalsBeadChipids: any[] = [];
  mapOfProcessStepsStatus = new Map();
  selectedProcessStep: string;
  processStepChemicals: any;
  minPriorityPlate = 10;
  isProcessUpdateProxied: boolean;
  index: number =0;
  arrayLoadingConfirmationPopupVisible = false
  axiom384Plates: Axiom384PlateMeta[] = [];
  axiom384PlateTableColumns: any[] = [];

  constructor(private platePreparationService:MaPlatePreparationService,private masterDataService: MasterDataService,
    private _messagesService: MessagesService,private storageService: MaStorageService, private resultEvaluationService: MaResultEvaluationService,
    private announcementService:AnnouncedService) { }

  ngOnInit() {
    this.puid = localStorage.getItem("PUID");
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;

    this.fetchAllActiveMachines();
    this.setMapOfStatusSaves();
    this.setMapOfProcessStepsStatus();
    this.setMapOfProcessStepsFlow();
    this.setMapOfProcessStepAndAction();
    this.setMapOfActionRuntime();
    this.setMapOfStatusAndLabel();

    this.isProcessUpdateProxied = this.selectedWorkFlow.proxyWeatherbyAPI

    this.multiUpdateProcessStepsMap = new Map();
    this.multiBeadChipStepsMap = new Map();
    this.multiUpdateBeadChipList= [];
    this.multiUpdateBeadChipInfoList = [];
    this.enteredBeadChipId= "";

    this.axiom384Plate2 = new Plate()
    this.axiom384Plate3 = new Plate()
    this.axiom384Plate4 = new Plate()
    this.axiom384Plate2.samples = [];
    this.axiom384Plate3.samples = [];
    this.axiom384Plate4.samples = [];

    this.load384BeadChipLiquidHandler = ""
    this.load384BeadChipChemicals = [];
    this.axiom384Beadchip = ""
    this.axiom384PlateID2 = ""
    this.axiom384PlateID3 = ""
    this.axiom384PlateID4 = ""

    this.axiom384PlateTableColumns = [
      {header: 'Quadrant', field: 'quadrant', width: '10%'},
      {header: 'Source Plate', field: 'plateID', width: '20%'},
      {header: 'Last Updated Plate', field: 'lastUpdatedID', width: '20%'},
      {header: 'Status', field: 'status', width: '50%'}
    ]
  }

  fetchAllActiveMachines(){
    this.blocked = true;
    this.masterDataService.getConfigList(this.selectedLabId, "machine", 0, 1000).subscribe(
      results => {
        this.blocked = false;
        if (!results) {
          return;
        }
        this.machinesList = results.data;
        this.machinesList.forEach(machine => {
          this.machinesBarcodeMap.set(machine.barcode, machine);
        })
      }
    )
  }

  setMapOfStatusSaves(){
    this.mapOfStatusSaves.set(BeadChipStatus.HYBRIDIZATION_STARTED, "assembleChamber");
    this.mapOfStatusSaves.set(BeadChipAction.INCUBATE_48C, "actionIncubate48c");
    this.mapOfStatusSaves.set(BeadChipAction.WASH_AND_STAIN_PREP, "actionWashAndStainPrep");
    this.mapOfStatusSaves.set(BeadChipStatus.WAITING_FOR_ANALYSIS, "waitingForAnalysis");
    this.mapOfStatusSaves.set(BeadChipAction.GENE_TITAN_WORKFILE, "actionGeneTitanWorkfile");
    this.mapOfStatusSaves.set(BeadChipStatus.COMPLETED, "resultFileSent");
  }

  setMapOfProcessStepsStatus(){
    this.mapOfProcessStepsStatus.set(BeadChipStatus.LOADED,[]);
    this.mapOfProcessStepsStatus.set(BeadChipStatus.HYBRIDIZATION_STARTED, [BeadChipProcessStep.HYBRIDIZATION]);
    this.mapOfProcessStepsStatus.set(BeadChipAction.INCUBATE_48C,[BeadChipProcessStep.HYBRIDIZATION]);
    this.mapOfProcessStepsStatus.set(BeadChipAction.WASH_AND_STAIN_PREP,[BeadChipProcessStep.HYBRIDIZATION]);
    this.mapOfProcessStepsStatus.set(BeadChipStatus.GENE_TITAN_LOADED, [])
    this.mapOfProcessStepsStatus.set(BeadChipStatus.COMPLETED, []);
  }

  setMapOfProcessStepsFlow(){
    // This map holds the flow of process steps that a beadchip has to go through
    this.mapOfProcessStepsFlow.set(BeadChipProcessStep.HYBRIDIZATION, [BeadChipProcessStep.LOADING])
    this.mapOfProcessStepsFlow.set(BeadChipProcessStep.EVALUTION, [BeadChipProcessStep.HYBRIDIZATION])
  }

  setMapOfProcessStepAndAction(){
    this.mapOfProcessStepAndAction.set(BeadChipProcessStep.HYBRIDIZATION, [BeadChipAction.INCUBATE_48C, BeadChipAction.WASH_AND_STAIN_PREP])
  }

  setMapOfActionRuntime(){
    this.mapOfActionRuntime.set(BeadChipAction.GENE_TITAN_WORKFILE, 0)
    this.mapOfActionRuntime.set(BeadChipAction.INCUBATE_48C, 1410)
    this.mapOfActionRuntime.set(BeadChipAction.WASH_AND_STAIN_PREP, 0)
    this.mapOfActionRuntime.set(BeadChipAction.GENE_TITAN_LOADED, 0)
  }

  setMapOfStatusAndLabel(){
    this.mapOfStatusAndLabel.set(BeadChipStatus.HYBRIDIZATION_STARTED, "Incubate 48°C")
    this.mapOfStatusAndLabel.set(BeadChipAction.WASH_AND_STAIN_PREP,"Wash And Stain Prep")
    this.mapOfStatusAndLabel.set(BeadChipAction.GENE_TITAN_LOADED,"GeneTitan Loaded")
    this.mapOfStatusAndLabel.set(BeadChipStatus.RESULT_FILE_SENT,"Result File Sent")
  }

  resetData(){
    this.axiom384Plate1 = new Plate()
    this.axiom384Plate2 = new Plate()
    this.axiom384Plate3 = new Plate()
    this.axiom384Plate4 = new Plate()
    this.axiom384Plate1.samples = [];
    this.axiom384Plate2.samples = [];
    this.axiom384Plate3.samples = [];
    this.axiom384Plate4.samples = [];

    this.load384BeadChipLiquidHandler = ""
    this.load384BeadChipChemicals = [];
    this.axiom384Beadchip = ""
    this.axiom384PlateID1 = ""
    this.axiom384PlateID2 = ""
    this.axiom384PlateID3 = ""
    this.axiom384PlateID4 = ""

    this.selectedBeadChipPlate = new Plate();
    this.multiBeadChipStepsMap = new Map();
    this.selectedBeadChipStepsMap = new Map();
    this.multiUpdateProcessStepsMap = new Map();
    this.arrayLoadingConfirmationPopupVisible = false
  }

  disableLoadBeadchipButton(){
    let disable = true;
    disable = this.isEmptyString(this.axiom384Beadchip.trim()) || ((this.isEmptyString(this.axiom384Plate1.plateID) && this.isEmptyString(this.axiom384Plate2.plateID) && this.isEmptyString(this.axiom384Plate3.plateID) && this.isEmptyString(this.axiom384Plate4.plateID)));
    return disable;
  }

  isEmptyString(val: string){
    return (!val || val==null || val==='')
  }

  isEmptyDate(val: Date){
    return (!val || val==null)
  }

  isValidProcessStep(stepName: string): boolean {
    let stepsMap = this.multiBeadChip ? this.multiUpdateProcessStepsMap : this.selectedBeadChipStepsMap;
    return (stepsMap.has(stepName));
  }

  isValidProcessStepAction(stepName: string){
    let stepsMap = this.multiBeadChip ? this.multiUpdateProcessStepsMap : this.selectedBeadChipStepsMap;
    return ( stepsMap.has(stepName));
  }

  isValidProcessStepActionPerformed(stepName: string, actionName: string){
    let stepsMap = this.multiBeadChip ? this.multiUpdateProcessStepsMap : this.selectedBeadChipStepsMap;
    return ( stepsMap.has(stepName) && stepsMap.get(stepName).actionMap.has(actionName));
  }

  getProcessStepStartPuid(stepName: string): string {
    let stepsMap = this.multiBeadChip ? this.multiUpdateProcessStepsMap : this.selectedBeadChipStepsMap;
    return stepsMap.get(stepName).startPUID;
  }

  getProcessStepEndPuid(stepName: string): string {
    let stepsMap = this.multiBeadChip ? this.multiUpdateProcessStepsMap : this.selectedBeadChipStepsMap;
    return stepsMap.get(stepName).endPUID;
  }

  getProcessStepStartTimestamp(stepName: string): Date {
    let stepsMap = this.multiBeadChip ? this.multiUpdateProcessStepsMap : this.selectedBeadChipStepsMap;
    return this.multiBeadChip? stepsMap.get(stepName).startTimeStamp : this.convertUtcToLocal(stepsMap.get(stepName).startTimeStamp);
  }

  getProcessStepEndTimestamp(stepName: string): Date {
    let stepsMap = this.multiBeadChip ? this.multiUpdateProcessStepsMap : this.selectedBeadChipStepsMap;
    return this.multiBeadChip? stepsMap.get(stepName).endTimeStamp: this.convertUtcToLocal(stepsMap.get(stepName).endTimeStamp);
  }

  getProcessStepActionPuid(stepName: string, actionName: string){
    let stepsMap = this.multiBeadChip ? this.multiUpdateProcessStepsMap : this.selectedBeadChipStepsMap;
    return stepsMap.get(stepName).actionMap.get(actionName).actionPUID;
  }

  getProcessStepActionTimeStamp(stepName: string, actionName: string){
    let stepsMap = this.multiBeadChip ? this.multiUpdateProcessStepsMap : this.selectedBeadChipStepsMap;
    return this.multiBeadChip? stepsMap.get(stepName).actionMap.get(actionName).actionStartTime : this.convertUtcToLocal(stepsMap.get(stepName).actionMap.get(actionName).actionStartTime);
  }

  updateBeadChipPlate() {
    if(!this.isPUIDPresent()){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before moving ahead',
      });
      return;
    }
    this.selectedBeadChipPlate.processSteps.forEach(function(action){delete action.actionMap});
    this.blocked = true;
    this.platePreparationService.updatePlate(this.selectedBeadChipPlate.plateID, this.selectedBeadChipPlate, this.selectedLabId).subscribe({
      next : (result) => {
        this.blocked = false;
        this.selectedBeadChipPlate = result;
        if(this.selectedBeadChipPlate.status === BeadChipStatus.WAITING_FOR_ANALYSIS){
          this.prepareSampleDataList<Sample>(this.selectedBeadChipPlate.samples, (sample) => {
            return {
              sampleId : sample._id,
              description : "",
              stageGate : 4,
              status : ProcessUpdateStage.STAGE_GATE
            }
          })
          this.performProcessUpdateForWeatherby()
        }
        this.selectedBeadChipStepsMap = this.prepareProcessStepsMap(this.selectedBeadChipPlate);
        this.updateBeadChipDataEmitter.emit(this.selectedBeadChipPlate);
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'BeadChip '+this.selectedBeadChipPlate.plateID+' is updated',
          detail: this.selectedBeadChipPlate.plateID+' has been updated successfully with requested status'
        })
        if(this.selectedProcessFlowConfig.resultEvaluation && this.selectedBeadChipPlate.status == BeadChipStatus.WAITING_FOR_ANALYSIS){
          this.createNewArraysForResultEvaluation([this.selectedBeadChipPlate.plateID]);
        }
        this.reloadTableEmitter.emit();
      },   error: (error: any) => {
        this.blocked = false;
        this.showError(error);
      }
    })
  }

  disableButton(stage: number, stepName: string, actionName: string, actionPos: number): boolean{
    if(this.multiBeadChip){
      return false;
    }
    if((!this.selectedBeadChipStepsMap || this.selectedBeadChipStepsMap==null || this.selectedBeadChipStepsMap.size < 1)){
      return false;
    }
    switch(stage){
      case ProcessStepStage.start:
        return this.disableProcessStepStart(stepName,this.selectedBeadChipStepsMap);
      case ProcessStepStage.end:
        return this.disableProcessStepEnd(stepName,this.selectedBeadChipStepsMap);
      case ProcessStepStage.action:
        return this.disableProcessStepAction(stepName, actionName, actionPos,this.selectedBeadChipStepsMap);
      default:
        return true;
    }
  }

  disableProcessStepStart(stepName: string, selectedPlateStepsMap:Map<string, Step>): boolean {
    let dependentSteps: string[] = this.mapOfProcessStepsFlow.get(stepName);
    let disable: boolean = true;
    for(let step of dependentSteps){
      if(step==BeadChipProcessStep.LOADING){
        disable = !selectedPlateStepsMap.has(step) || this.isEmptyString(selectedPlateStepsMap.get(step).startPUID) || this.isEmptyDate(selectedPlateStepsMap.get(step).startTimeStamp);
        break;
      }
      let dependentProcessStep = selectedPlateStepsMap.get(step);
      if(dependentProcessStep && !this.isEmptyString(dependentProcessStep.endPUID) && !this.isEmptyDate(dependentProcessStep.endTimeStamp)){
        disable = false;
      }else{
        disable = true;
        break;
      }
    }
    if(selectedPlateStepsMap.has(stepName)){
      disable = true;
    }
    return disable;
  }

  disableProcessStepAction(stepName: string, actionName: string, actionPos: number, selectedPlateStepsMap:Map<string, Step>): boolean{
    if(!selectedPlateStepsMap.has(stepName)){
      return true;
    }
    let disable: boolean = true;
    let processStepActions : string[] = this.mapOfProcessStepAndAction.get(stepName);
    let currentProcessStep = selectedPlateStepsMap.get(stepName);
    if(actionPos==0){
      disable = currentProcessStep.actionMap.has(actionName);
    }else{
      if(!currentProcessStep.actionMap.has(actionName) && currentProcessStep.actionMap.has(processStepActions[0])){
        disable = false;
      }
    }
    if(actionName==BeadChipAction.GENE_TITAN_LOADED && !currentProcessStep.actionMap.has(actionName)){
      disable = !currentProcessStep.endPUID
    }
    return disable;
  }

  disableProcessStepEnd(stepName: string, selectedPlateStepsMap:Map<string, Step>): boolean {
    if(!selectedPlateStepsMap.has(stepName)){
      return true;
    }
    let disable: boolean = true;
    let processStepActions : string[] = this.mapOfProcessStepAndAction.get(stepName);
    let currentProcessStep = selectedPlateStepsMap.get(stepName);
    if(processStepActions && processStepActions.length>1){
      let previousAction = processStepActions[1];
      disable = !currentProcessStep.actionMap.has(previousAction);
    }else if(processStepActions && processStepActions.length>0){
      let previousAction = processStepActions[0];
      disable = !currentProcessStep.actionMap.has(previousAction);
    }else{
      disable = false;
    }
    if(!this.isEmptyString(currentProcessStep.endPUID) && this.isEmptyDate(currentProcessStep.endTimeStamp)){
      disable = true
      return disable
    }
    if(!this.isEmptyString(currentProcessStep.endPUID) && !this.isEmptyDate(currentProcessStep.endTimeStamp)){
      disable = true;
    }
    return disable;
  }

  convertUtcToLocal(date: Date): Date{
    if(!date || date==null) return;
    let offset = new Date().getTimezoneOffset();
    let dateInLocal = new Date(date);
    dateInLocal.setMinutes(dateInLocal.getMinutes()-offset);
    return dateInLocal;
  }

  isPUIDPresent() {
    if (this.puid != null && this.puid != undefined && this.puid != '') {
      return true;
    }
    return false;
  }

  showError(error: any) {
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  prepareProcessStepsMap(plate: Plate) {
    let plateStepsMap: Map<string, Step> = new Map();
    if(!plate || plate==null){
      return plateStepsMap;
    }
    plate.processSteps.forEach(step => {
      step.actionMap = new Map();
      step.action.forEach(s => {
        step.actionMap.set(s.action, s);
      })
      plateStepsMap.set(step.step, step);
    })
    return plateStepsMap;
  }

  checkMachineBarcode(machineBarcodeVar:string, focusElementId: string){
    let machineBarcode = this[machineBarcodeVar];
    if(machineBarcode.trim() == ""){
      return;
    }
    if(!this.machinesBarcodeMap.has(machineBarcode)){
      this._messagesService.addErrorMessage({
        severity:"error", summary:"Machine not found!",
        detail: "Machine with barcode "+machineBarcode+" not found. Please check the barcode and scan again."
      })
      this[machineBarcodeVar] = "";
      return;
    }

    this.findAndHighlightElement(focusElementId)

    return;
  }

  findAndHighlightElement(elementId){
    let element = document.getElementById(elementId);
    if(element){
      element.focus();
    }
  }

  validateArrayIDForAxiom384(){
    let arrayID = this.axiom384Beadchip.trim();
    if (this.isEmptyString(arrayID)) {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Empty',
        detail: 'Scan a valid ArrayID'
      })
      return;
    }
    if(arrayID.length > this.selectedWorkFlow.maxArrayIDSize){
      this._messagesService.addWarningMessage({
        severity:'warn',summary:'Max limit on array ID excedeed!!!',
        detail:`Please provide an ID of length less than ${this.selectedWorkFlow.maxArrayIDSize}`
      });
      return;
    }
    this.blocked = true;
    this.platePreparationService.fetchPlate(arrayID,this.selectedLabId).subscribe(
      (_result)=>{
        this.blocked = false;
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Duplicate Array ID!', detail: "Please scan a new ArrayId !! Array with "+arrayID+" already exists!!" });
        this.axiom384Beadchip = "";
      },
      (_error)=>{
        this.blocked = false;
        let workFlowPartNr = this.selectedWorkFlow.arrayPartNumber
        if(arrayID.startsWith(workFlowPartNr)){
          this.load384BeadChipChemicals = [
            {
              "chemical":"Axiom384Propel",
              "lots": [arrayID.slice(6,13)]
            }
          ]
          this.findAndHighlightElement("scan-384-plate-1")
        }
        else{
          this._messagesService.addWarningMessage({
            severity: 'warn', summary: 'Invalid Array ID',
            detail: 'ArrayID Part Nr does not match with workflow Array Part Number'+workFlowPartNr
          })
          this.axiom384Beadchip = "";
          return;
        }
      }
    )
  }

  restorePlatesFromStorage(plates:string[] = []){
    let body = {
      "labid":this.selectedLabId,
      "plateids":plates
    }
    this.blocked = true
    this.storageService.removeMultiplePlatesFromStorage(body).subscribe(
      _r => {
        let data = {
          'plateIDs':plates
        }
        this.storageService.restorePlatesFromStorage(this.selectedLabId,data).subscribe(
          _r => {
            this.blocked = false
          },
          error => {
            this.blocked = false
            this._messagesService.addErrorMessage({
              severity:'error',summary:'Something went wrong while restoration',
              detail:error
            })
          }
        )
      },
      error => {
        this.blocked = false
        this._messagesService.addErrorMessage({
          severity:'error',summary:'Something went wrong while restoration',
          detail:error
        })
      }
    )
  }

  validatePlateForAxiom384(wgaPlateID: string, pos: number){
    if (this.isEmptyString(wgaPlateID)) {
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Empty',
        detail: 'Scan a valid plateID'
      })
      this["axiom384Plate"+pos] = new Plate();
      this["axiom384PlateID"+pos] = "";
      return;
    }
    if((this.axiom384PlateID1 === wgaPlateID && 1 != pos) || (this.axiom384PlateID2 === wgaPlateID && 2 != pos) || (this.axiom384PlateID3 === wgaPlateID && 3 != pos) || (this.axiom384PlateID4 === wgaPlateID && 4 != pos) ){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'WGA Plate already scanned',
        detail: 'WGA Plate Already Scanned. Please scan a new plate.',
      });
      this["axiom384PlateID"+pos] = "";
      this.findAndHighlightElement("scan-384-plate-"+pos);
      return;
    }
    this.blocked = true;
    this.platePreparationService.fetchPlate(this["axiom384PlateID" + pos], this.selectedLabId).subscribe(
      result => {
        this.blocked = false;
        let plate: Plate = result;
        this.minPriorityPlate = Math.min(this.minPriorityPlate,plate.priority)
        if(plate.status==PlateStatus.COMPLETLY_TRANSFERED){
          this['axiom384PlateID'+pos] = "";
          this._messagesService.addWarningMessage({
            severity: 'warn', summary: 'Invalid action',
            detail: 'Plate has already been transfered'
          })
          return;
        }
        else if(plate.status !==  PlateStatus.DENATURATION_COMPLETED){
          this['axiom384PlateID'+pos] = "";
          this._messagesService.addWarningMessage({
            severity: 'warn', summary: 'Invalid action',
            detail: `Given plate must be in ${PlateStatus.DENATURATION_COMPLETED} in order to create an array`
          })
          return;
        }
        this["axiom384Plate"+pos] = plate
        this["axiom384PlateID"+pos] = plate.lastUpdatedPlateID
        if(pos != 4){
          pos = pos + 1;
          this.findAndHighlightElement("scan-384-plate-"+pos);
        }
        else{
          this.findAndHighlightElement("create-array-button");
        }
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Success',
          detail: 'Plate '+wgaPlateID+' is valid'
        })
        if(plate.storagePlate && plate.status !== PlateStatus.STORAGE_PLATE){
          this.restorePlatesFromStorage([plate.lastUpdatedPlateID])
        }
      }, (error) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to fetch plate info',
          detail: error.error.bbApiError.message
        });
        this["axiom384PlateID"+pos] = "";
        this.findAndHighlightElement("scan-384-plate-"+pos);
      }
    )

  }
  validateAndConfirmPlateSelection() {
    if(this.isEmptyString(this.axiom384Beadchip) || (this.isEmptyString(this.axiom384PlateID1) && this.isEmptyString(this.axiom384PlateID2) && this.isEmptyString(this.axiom384PlateID3) && this.isEmptyString(this.axiom384PlateID4)) ){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Invalid data',
        detail: 'Please scan all input fields above to proceed'
      })
      return;
    }

    this.axiom384Plates = []

    for(let i = 1; i < 5; i++) {
      if(this[`axiom384PlateID${i}`]) {
        const plate = this[`axiom384Plate${i}`]
        this.axiom384Plates.push({quadrant: `Q${i}`, plateID: plate.plateID, lastUpdatedID: plate.lastUpdatedPlateID, status: plate.status})
      }
    }

    this.arrayLoadingConfirmationPopupVisible = true;
  }

  loadBeadchipForAxiom384(){

    const beadchipAxiom384 = new LoadBeadchipAxiom384();
    beadchipAxiom384.processFlow = BeadChipProcessFlows.AXIOM_384;
    beadchipAxiom384.beadchipID = this.axiom384Beadchip;
    beadchipAxiom384.plateID1 = this.axiom384Plate1.plateID;
    beadchipAxiom384.lastUpdatedPlateID1 = this.axiom384PlateID1;
    beadchipAxiom384.plate1Samples = this.axiom384Plate1.samples
    beadchipAxiom384.plate1ProcessFlowName = this.axiom384Plate1.processFlowName;
    beadchipAxiom384.plateID2 = this.axiom384Plate2.plateID;
    beadchipAxiom384.lastUpdatedPlateID2 = this.axiom384PlateID2;
    beadchipAxiom384.plate2Samples = this.axiom384Plate2.samples
    beadchipAxiom384.plate2ProcessFlowName = this.axiom384Plate2.processFlowName;
    beadchipAxiom384.plateID3 = this.axiom384Plate3.plateID;
    beadchipAxiom384.lastUpdatedPlateID3 = this.axiom384PlateID3;
    beadchipAxiom384.plate3Samples = this.axiom384Plate3.samples
    beadchipAxiom384.plate3ProcessFlowName = this.axiom384Plate3.processFlowName;
    beadchipAxiom384.plateID4 = this.axiom384Plate4.plateID;
    beadchipAxiom384.lastUpdatedPlateID4 = this.axiom384PlateID4;
    beadchipAxiom384.plate4Samples = this.axiom384Plate4.samples;
    beadchipAxiom384.plate4ProcessFlowName = this.axiom384Plate4.processFlowName;
    beadchipAxiom384.puid = this.puid;
    beadchipAxiom384.datetime = new Date();
    beadchipAxiom384.workFlow = this.axiom384Plate1.workFlow;
    beadchipAxiom384.sampleType = this.axiom384Plate1.sampleType;
    beadchipAxiom384.sender = this.axiom384Plate1.sender;
    beadchipAxiom384.liquidHandler = this.load384BeadChipLiquidHandler;
    beadchipAxiom384.chemicals = this.load384BeadChipChemicals;
    beadchipAxiom384.processFlowName = this.axiom384Plate1.processFlowName;
    beadchipAxiom384.priority = this.minPriorityPlate;
    beadchipAxiom384.reRun = (this.axiom384Plate1.reRun || this.axiom384Plate2.reRun || this.axiom384Plate3.reRun || this.axiom384Plate4.reRun)
    this.blocked = true;
    this.platePreparationService.loadBeadchips(this.selectedLabId, beadchipAxiom384).subscribe({
      next : (result) => {
        this.blocked = false;
        if(result=="Success"){
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Successful',
            detail: 'Beadchip '+beadchipAxiom384.beadchipID +' has been loaded successfully'
          })
          this.actionGeneTitanWorkfile(this.axiom384Beadchip);
          this.resetData();
          this.reloadTableEmitter.emit();
        }else{
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Failed',
            detail: 'Failed to load beadchip '+beadchipAxiom384.beadchipID+', please try again'
          })
          this.resetData();
          this.reloadTableEmitter.emit();
        }
      },error: (_error: any) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed',
          detail: 'Failed to load beadchip '+beadchipAxiom384.beadchipID+', please try again'
        })
      }
    })
  }

  actionGeneTitanWorkfile(beadChipPlateID: string = ""){
    if(this.isEmptyString(beadChipPlateID)){
      beadChipPlateID = this.selectedBeadChipPlate.plateID;
    }
    this.blocked = true;
    this.platePreparationService.downloadGeneTitanWorkFile(this.selectedLabId, beadChipPlateID).subscribe(
      result => {
        this.blocked = false;
        this._messagesService.addSuccessMessage({
          severity:"success", summary:"File Download", detail:"Gene Titan Workfile Downloading..."
        })
        let blob = new Blob([result.fileContent], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        console.log("File name : " + result.filename);
        saveByFileSaver(blob, result.filename);
      },
      _error => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Error in downloading workfile!',
          detail: "Error in downloading genetitan workfile."
        });
      }
    );
  }

  waitingForAnalysis(status: string){
    if(!this.updateProcessStep(BeadChipProcessStep.HYBRIDIZATION, ProcessStepStage.end, status)){
      return;
    }
    this.selectedBeadChipPlate.status = status;
    this.updateBeadChipPlate();
  }

  assembleChamber(status: string){
    if(!this.updateProcessStep(BeadChipProcessStep.HYBRIDIZATION, ProcessStepStage.start, "")){
      return;
    }
    this.selectedBeadChipPlate.status = status;
    this.updateBeadChipPlate();
  }

  actionIncubate48c(status: string){
    if(!this.updateProcessStep(BeadChipProcessStep.HYBRIDIZATION, ProcessStepStage.action, status)){
      return;
    }
    this.updateBeadChipPlate();
  }

  actionWashAndStainPrep(status: string){
    if(!this.updateProcessStep(BeadChipProcessStep.HYBRIDIZATION, ProcessStepStage.action, status)){
      return;
    }
    this.selectedBeadChipPlate.status = status;
    this.updateBeadChipPlate();
  }

  updateProcessStep(step: string, stage: ProcessStepStage, actionName: string, liquidHandler: string = ""): boolean{
    if(this.selectedBeadChipStepsMap.has(step)){
      let existingStep = this.selectedBeadChipPlate.processSteps.find(s=>s.step == step);
      if(ProcessStepStage.start==stage){
        existingStep.startTimeStamp = new Date();
        existingStep.startPUID = this.puid;
        existingStep.liquidHandler = liquidHandler;
      }else if(ProcessStepStage.end==stage){
        existingStep.endTimeStamp = new Date();
        existingStep.endLiquidHandler = liquidHandler;
        existingStep.endPUID = this.puid;
      }else{
        if(existingStep.actionMap.has(actionName)){
          let existingAction = existingStep.action.find(a => a.action == actionName);
          existingAction.actionPUID = this.puid;
          existingAction.liquidHandler = liquidHandler;
          existingAction.actionStartTime = new Date();
        }else{
          existingStep.action = (!existingStep.action || existingStep.action==null) ? [] : existingStep.action;
          let newAction = new StepAction();
          newAction.action = actionName;
          newAction.actionPUID = this.puid;
          newAction.actionStartTime = new Date();
          newAction.liquidHandler = liquidHandler;
          newAction.actionRunTime = this.mapOfActionRuntime.get(actionName)
          existingStep.action.push(newAction);
          existingStep.actionMap.set(actionName, newAction);
        }
      }
    }else{
      this.selectedBeadChipPlate.processSteps = (!this.selectedBeadChipPlate.processSteps || this.selectedBeadChipPlate.processSteps==null) ? [] : this.selectedBeadChipPlate.processSteps;
      let newStep = new Step();
      newStep.step = step;
      if(ProcessStepStage.start==stage){
        newStep.startTimeStamp = new Date();
        newStep.startPUID = this.puid;
        //server is forcing to put default/dummy values, otherwise it is throwing 500
        newStep.action = [];
        newStep.chemicals = [];
        newStep.liquidHandler = ""
        newStep.endPUID = "";
        newStep.endTimeStamp = null;
      }else{
        this._messagesService.addWarningMessage({
          severity: 'warn', summary: 'Action not allowed',
          detail: 'Process has to be started to perform this action'
        })
        return false;
      }
      this.selectedBeadChipPlate.processSteps.push(newStep)
    }
    return true;
  }

  saveBeadChipStatus(status: string,stage: number, stepName: string, actionName: string, actionPos: number) {
    if(this.isMultiPlateOrDetailedWorkflow()){
      if(status == BeadChipAction.INCUBATE_48C){
        this.saveBeadChipStatus(BeadChipStatus.HYBRIDIZATION_STARTED, 0, BeadChipProcessStep.HYBRIDIZATION, '', 0)
        return;
      }
      this.multiStage = stage;
      this.multiActionName = actionName;
      this.multiActionPos =  actionPos;
      this.multiStepName = stepName;
      this.multiUpdateStatus = status;

      this.enteredBeadChipId ="";
      this.multiUpdateBeadChipList = [];
      this.multiUpdateBeadChipInfoList = [];
      if(status==BeadChipStatus.HYBRIDIZATION_STARTED){
        this.popUpWithDifferentMachine = true;
        this.processStepStartTime = (new Date()).toISOString();
        setTimeout(() => {
          this.findAndHighlightElement("popUpWithDifferentMachine-popup-machineid")
        }, 100);
      }
      else if(status==BeadChipAction.WASH_AND_STAIN_PREP){
        this.openPopUpForWashAndStainPrep();
      }
      else if(status==BeadChipStatus.WAITING_FOR_ANALYSIS){
        this.popUpWithDifferentMachineAndChemicals = true;
        setTimeout(() => {
          this.findAndHighlightElement("popUpWithDifferentMachineAndChemicals-popup-machineid")
        }, 100);
      }
    }
    else{
      let funtionName = this.mapOfStatusSaves.get(status);
      this[funtionName](status);
    }
  }

  disableGeneTitanWorkfile(){
    return !this.selectedBeadChipPlate || !this.selectedBeadChipPlate.plateID
  }

  disableDataExportEvaluation(){
    return !this.selectedBeadChipPlate || !this.selectedBeadChipPlate.plateID
  }
  showChemicalPopup(open: boolean, processStep?: string) {

    this.selectedProcessStep = processStep;
    this.blocked = true;
    this.masterDataService.getAllActiveChemicals(this.selectedLabId, "chemical").subscribe({
      next : (result) => {
        this.blocked = false;
      this.processStepChemicals = result.data.filter(chemical => (chemical.processStep === processStep));
    },error: (error: any) => {
      this.blocked = false;
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error });
    }});

    if(this.selectedBeadChipPlate.status && !this.mapOfProcessStepsStatus.get(this.selectedBeadChipPlate.status).includes(processStep) || this.selectedBeadChipPlate.status == null){
      this.noChemicalEdit = true;
    } else {
      this.noChemicalEdit = false;
    }

    if(this.lastUpdatedStatus && !this.mapOfProcessStepsStatus.get(this.lastUpdatedStatus).includes(processStep) || this.lastUpdatedStatus == null || this.lastUpdatedStatus == '' || this.selectedBeadChipPlate.plateID){
      this.multiChemicalEdit = false;
    } else {
      this.multiChemicalEdit = true;
    }

    this.showDialogue= true;
  }

  calculateRemainingTimeForAction(stepName: string, actionName: string){
    let stepsMap = this.multiBeadChip ? this.multiUpdateProcessStepsMap : this.selectedBeadChipStepsMap;
    if (stepsMap.get(stepName).actionMap && stepsMap.get(stepName).actionMap.get(actionName) != undefined && stepsMap.get(stepName).actionMap.get(actionName) != null) {
      let actionStartTime: Date = this.getProcessStepActionTimeStamp(stepName, actionName);
      let actionRunTime: number = stepsMap.get(stepName).actionMap.get(actionName).actionRunTime;
      return this.calculatingTimes(this.calculateRemainingTime(actionRunTime, actionStartTime));
    } else {
      let actionRunTime = this.mapOfActionRuntime.get(actionName);
      return this.calculatingTimes(actionRunTime * 60);
    }
  }

  calculatingTimes(timeLeftInSecs: number) {
    let timeLeft = Math.floor(timeLeftInSecs);
    if (timeLeft == 0)
      return "00:00:00";
    let sec = 0, min = 0, hr = 0
    if (timeLeft % 60 != 0) {
      sec = timeLeft % 60;
      timeLeft = timeLeft - sec;
    }
    timeLeft = timeLeft / 60;
    if (timeLeft % 60 != 0) {
      min = timeLeft % 60;
      timeLeft = timeLeft - min;
    }
    timeLeft = timeLeft / 60;
    hr = timeLeft;
    let secStr = "00" + sec, minStr = "00" + min, hrStr = "00" + hr
    return hrStr.substring(hrStr.length - 2) + ':' + minStr.substring(minStr.length - 2) + ":" + secStr.substring(secStr.length - 2);
  }

  calculateRemainingTime(actionRunTime: number, actionStartTime: Date) {
    let currentDateLocal = new Date();
    if(actionStartTime.getTime()+actionRunTime*60*1000 <= currentDateLocal.getTime()){
      return 0;
    }
    return (actionStartTime.getTime()+actionRunTime*60*1000 - currentDateLocal.getTime())/1000;
  }

  disableResultfilesSent(){
    if(this.selectedBeadChipPlate && this.selectedBeadChipPlate.status==BeadChipStatus.GENE_TITAN_LOADED){
      return false;
    }
    return true;
  }

  hideChemicalDialog(beadChip: Plate){
    this.showDialogue = false;
    if (beadChip.plateID !== undefined)
      this.updateBeadChipDataEmitter.emit(beadChip);
  }

  closeMultiUpdatePopup(reloadTable: boolean= true) {
    this.popUpWithDifferentMachine = false;
    this.popUpWithDifferentMachineAndChemicals = false;
    this.multiUpdateBeadChipList = [];
    this.multiUpdateBeadChipInfoList = [];
    this.enteredBeadChipId = "";
    this.multiLiquidHandler = "";
    this.processStepStartTime = "";
    this.selectedBeadChipPlate = new Plate();

    this.washAndStainPopUp = false;
    this.washStainPrepEligibleArrays = [];
    this.washAndStainTableSelectedRows = [];
    this.multiDestaticStainsCheckboxValue = false;
    this.multiPrepareStainsCheckboxValue = false;

    this.stabilizationChemical = "";
    this.stabilizationChemicalList = [];
    this.stabilizationEquipment = "";
    this.stain1Chemical = "";
    this.stain1ChemicalList = [];
    this.stain1Equipment = "";
    this.stain2Chemical = "";
    this.stain2ChemicalList = [];
    this.stain2Equipment = "";
    this.ligationChemical = "";
    this.ligationChemicalList = [];
    this.ligationEquipment = "";
    this.holdBufferChemical = "";
    this.holdBufferChemicalList = [];
    this.holdBufferEquipment = "";

    this.washAChemical = "";
    this.washAChemicalList = [];
    this.washBChemical = "";
    this.washBChemicalList = [];
    this.axiomWaterChemical = "";
    this.axiomWaterChemicalList = [];

    if(reloadTable){
      this.reloadTableEmitter.emit();
    }
  }

  checkBeadChip(){
    if((this.popUpWithDifferentMachine || this.popUpWithDifferentMachineAndChemicals) && (this.multiLiquidHandler.trim()=="")){
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Please scan equipment'});
      return;
    }
    if(this.enteredBeadChipId && this.multiUpdateBeadChipList && this.multiUpdateBeadChipList.includes(this.enteredBeadChipId)) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Duplicate BeadChip', detail: 'BeadChip already Scanned.' });
      this.enteredBeadChipId = "";
      return;
    }
    if(this.enteredBeadChipId && this.multiUpdateBeadChipList && this.multiUpdateBeadChipList.length>20) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Max BeadChips Reached', detail: '20 BeadChips already Scanned.' });
      this.enteredBeadChipId = "";
      return;
    }
    if(this.enteredBeadChipId && this.enteredBeadChipId =="") {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Empty BeadChip', detail: 'Please scan a BeadChip.' });
      return;
    }
    this.blocked = true;
    this.platePreparationService.processDetailsbyPlateId(this.selectedLabId, this.enteredBeadChipId, "SOURCE").subscribe(
      result => {
        this.blocked = false;
        this.fetchedBeadChipPlate = result;
        this.prepareProcessStepMapforMultiBeadChipUpdate();
        let notEligible = this.eligibleBeadChip(this.multiStage, this.multiStepName, this.multiActionName, this.multiActionPos);
        if(notEligible){
          this._messagesService.addWarningMessage({severity: 'warn', summary: 'Invalid', detail: 'Beadchip '+this.enteredBeadChipId+ ' is not eligible to perform this process step'});
          this.enteredBeadChipId = "";
        }else{
          this.multiUpdateBeadChipList.unshift(this.enteredBeadChipId);
          if(this.popUpWithDifferentMachine){
            let plateUpdateInfo = new BeadChipUpdateInfo()
            plateUpdateInfo.beadChipID = this.fetchedBeadChipPlate.plateID;
            plateUpdateInfo.liquidHandler = this.multiLiquidHandler;
            plateUpdateInfo.chemicals = [];
            plateUpdateInfo.addFirstAction = {
              "name":BeadChipAction.INCUBATE_48C,
              "runTime": this.mapOfActionRuntime.get(BeadChipAction.INCUBATE_48C),
              "liquidHandler": this.multiLiquidHandler
            }
            this.multiUpdateBeadChipInfoList.unshift(plateUpdateInfo)
          }
          else if(this.popUpWithDifferentMachineAndChemicals){
            let plateUpdateInfo = new BeadChipUpdateInfo()
            plateUpdateInfo.beadChipID = this.fetchedBeadChipPlate.plateID;
            plateUpdateInfo.liquidHandler = this.multiLiquidHandler;
            plateUpdateInfo.chemicals = [];
            this.multiUpdateBeadChipInfoList.unshift(plateUpdateInfo)
          }
          this.enteredBeadChipId = "";
        }
      }, (_error)=>{
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: "error", summary: "Plate not found!",
          detail: "Plate not found with plate id - " + this.enteredBeadChipId
        })
        this.enteredBeadChipId = "";
      }
    )
  }

  prepareProcessStepMapforMultiBeadChipUpdate() {
    this.multiBeadChipStepsMap = new Map();
    if(!this.fetchedBeadChipPlate.processSteps || this.fetchedBeadChipPlate.processSteps==null)
      return;
    this.fetchedBeadChipPlate.processSteps.forEach(step => {
      step.actionMap = new Map();
      step.action.forEach(s => {
        step.actionMap.set(s.action, s);
      })
      this.multiBeadChipStepsMap.set(step.step, step);
    });
  }

  eligibleBeadChip(stage: number, stepName: string, actionName: string, actionPos: number){
    if((!this.multiBeadChipStepsMap || this.multiBeadChipStepsMap==null || this.multiBeadChipStepsMap.size < 1)){
      return true;
    }
    switch(stage){
      case ProcessStepStage.start:
        return this.disableProcessStepStart(stepName, this.multiBeadChipStepsMap);
      case ProcessStepStage.end:
        return this.disableProcessStepEnd(stepName, this.multiBeadChipStepsMap);
      case ProcessStepStage.action:
        return this.disableProcessStepAction(stepName, actionName, actionPos, this.multiBeadChipStepsMap);
      default:
        return true;
    }
   }

  deleteBeadChipFromMultiUpdateList(index: number, highlightId){
    this.multiUpdateBeadChipList.splice(index,1);
    this.multiUpdateBeadChipInfoList.splice(index,1);
    this.findAndHighlightElement(highlightId);
  }

  getMultiUpdateDto(): MultiBeadChipUpdate {
    let multiUpdate : MultiBeadChipUpdate = new MultiBeadChipUpdate();
    multiUpdate.action = this.multiActionName;
    multiUpdate.beadchipids = this.multiUpdateBeadChipList;
    multiUpdate.beadChipUpdateInfoList = this.multiUpdateBeadChipInfoList;
    multiUpdate.step = this.multiStepName;
    multiUpdate.labid = this.selectedLabId;
    multiUpdate.puid = this.puid;
    multiUpdate.status = this.multiUpdateStatus;
    multiUpdate.processStartTimeStamp = this.processStepStartTime
    multiUpdate.actionRunTime = this.mapOfActionRuntime.get(this.multiActionName);
    if(this.popUpWithDifferentMachine){
      multiUpdate.addFirstAction = true;
    }
    else if(this.popUpWithDifferentMachineAndChemicals){
      multiUpdate.chemicals = [
        {'chemical':"Wash A", "lots":this.washAChemicalList},
        {'chemical':"Wash B", "lots":this.washBChemicalList},
        {'chemical':"Axiom Water", "lots":this.axiomWaterChemicalList}
      ]
      multiUpdate.completeProcessStep = true;
    }
    return multiUpdate;
  }

  startAxiomHybridization(){
    let multiUpdateDto = this.getMultiUpdateDto();
    this.blocked = true;
    this.platePreparationService.updateStartProcessForMultipleBeadChips(multiUpdateDto as any).subscribe(
      (result) =>{
        this.blocked = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result })
        this.lastUpdatedStatus = multiUpdateDto.status;
        this.updateMultiUpdateProcessStep(this.multiStepName, this.multiStage, this.multiActionName)
        this.updateMultiUpdateProcessStep(BeadChipProcessStep.HYBRIDIZATION, 2, BeadChipAction.INCUBATE_48C)
        this.closeMultiUpdatePopup();
        this.multiBeadChip = true;
      },
      (error) =>{
        this.blocked = false;
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    )
  }

  completeGeneTitanLoaded(){
    let multiUpdateDto = this.getMultiUpdateDto();
    this.blocked = true;
    this.platePreparationService.updateActionForMultipleBeadChips(multiUpdateDto as any).subscribe(
      (result) =>{
        this.blocked = false;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Success', detail: result })
        this.lastUpdatedStatus = multiUpdateDto.status;
        this.prepareMultiPlateSampleData(multiUpdateDto,() => {
          this.performProcessUpdateForWeatherby()
        })
        this.updateMultiUpdateProcessStep(this.multiStepName, this.multiStage, this.multiActionName)
        this.createNewArraysForResultEvaluation(multiUpdateDto.beadchipids);
        this.closeMultiUpdatePopup();
        this.multiBeadChip = true;
      },
      (error) =>{
        this.blocked = false;
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    )
  }

  prepareSampleDataList<P extends string | Sample>(dataList: P[] , mappingFunction : (p:P) => SampleData){
    dataList.forEach(data => {
      let sampleData = mappingFunction(data)
      this.weatherbySampleDataList.push(sampleData)
    })
  }

  prepareMultiPlateSampleData(multiUpdateDTO:MultiBeadChipUpdate,callBack : () => void){
    let request = {
      "plateIDs":multiUpdateDTO.beadchipids
    }
    this.platePreparationService.fetchPlateWithSampleId(this.selectedLabId,request).subscribe(
      result => {
        let platesWithSample = result

        platesWithSample.forEach(plateAndSample => {
          let plateId = plateAndSample.lastUpdatedPlateID;
          let sampleIds = plateAndSample.samples

          let geneTitanMachineId : string

          let multiBeadChipUpdateList = multiUpdateDTO.beadChipUpdateInfoList
          if(multiBeadChipUpdateList === undefined){
            geneTitanMachineId = ""
          }
          else{
            let beadChipInfo = multiBeadChipUpdateList.find(beadChip => beadChip.beadChipID === plateId)
            geneTitanMachineId = beadChipInfo.liquidHandler
          }
          this.prepareSampleDataList<any>(sampleIds,sample => {
            return {
              sampleId : sample._id,
              description : geneTitanMachineId,
              status: ProcessUpdateStage.STAGE_GATE,
              stageGate : 4
            }
          })
        })
        callBack()
      },error => {
        this._messagesService.addErrorMessage({
          severity:'error',summary:'Something went wrong',
          detail:`Error occurred while sending process update to weatherby.Error: ${error.error.bbApiError.message} `
        })
        this.weatherbySampleDataList =[]
      }
    )
  }

  performProcessUpdateForWeatherby(){
    let weatherByProcessUpdateDto : ProcessUpdateDTO = {
      data :  this.weatherbySampleDataList,
      labId : this.selectedLabId
    }
    this.announcementService.weatherbyProcessUpdate(weatherByProcessUpdateDto,this.isProcessUpdateProxied).subscribe(
      _result => {
        this.weatherbySampleDataList = []
      },
      error => {
        this._messagesService.addErrorMessage({
          severity:'error',summary:'Something went wrong',
          detail:`Error occurred while sending process update to weatherby.Error: ${error.error.bbApiError.message} `
        })
        this.weatherbySampleDataList =[]
      }
    )
  }

  updateMultiUpdateProcessStep(step: string, stage: ProcessStepStage, actionName: string, liquidHandler=""){
    if(this.multiUpdateProcessStepsMap.has(step)){
      let existingStep = this.multiUpdateProcessStepsMap.get(step);
      if(ProcessStepStage.start==stage){
        existingStep.startTimeStamp = new Date();
        existingStep.startPUID = this.puid;
      }else if(ProcessStepStage.end==stage){
        existingStep.endTimeStamp = new Date();
        existingStep.endPUID = this.puid;
      }else{
        if(existingStep.actionMap.has(actionName)){
          let existingAction = existingStep.action.find(a => a.action == actionName);
          existingAction.actionPUID = this.puid;
          existingAction.actionStartTime = new Date();
        }else{
          existingStep.action = (!existingStep.action || existingStep.action==null) ? [] : existingStep.action;
          let newAction = new StepAction();
          newAction.action = actionName;
          newAction.actionPUID = this.puid;
          newAction.actionStartTime = new Date();
          newAction.actionRunTime = this.mapOfActionRuntime.get(actionName);
          existingStep.action.push(newAction);
          existingStep.actionMap.set(actionName, newAction)
        }
      }
    }else{
      let newStep = new Step();
      newStep.step = step;
      newStep.action = [];
      newStep.actionMap = new Map();
      if(ProcessStepStage.start==stage){
        newStep.startTimeStamp = new Date();
        newStep.startPUID = this.puid;
        newStep.liquidHandler = liquidHandler;
      }else if(ProcessStepStage.end==stage){
        newStep.endTimeStamp = new Date();
        newStep.endPUID = this.puid;
      }else{
        let newAction = new StepAction();
        newAction.action = actionName;
        newAction.actionPUID = this.puid;
        newAction.actionStartTime = new Date();
        newAction.actionRunTime = this.mapOfActionRuntime.get(actionName);
        newStep.actionMap.set(actionName, newAction);
      }
      this.multiUpdateProcessStepsMap.set(step, newStep)
    }
  }

  openPopUpForWashAndStainPrep(){
    let data = new WashAndStainPrepRequestDTO();
    data.labid = this.selectedLabId;
    data.processFlowNames = this.selectedWorkFlow.processFlow;
    this.blocked = true;
    this.platePreparationService.getArraysForWashAndStain(data).subscribe(
      result => {
        this.blocked = false;
        if(result.length == 0){
          this._messagesService.addWarningMessage({
            severity: "warn", summary:"Wash and Stain Prep not applicable!",
            detail: "Cannot proceed with Wash and Stain Preparation as no eligible arrays found!!"
          })
          return;
        }
        this.washStainPrepEligibleArrays = result
        this.washAndStainPopUp = true;
      },
      error => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity:"error", summary:"Array fetch failed!",
          detail: "Cannot proceed with Wash and Stain Preparation as no eligible arrays found!!"
        })
      }
    )
  }

  completeWashAndStainPreparation(){
    let updateDto = this.getWashAndStainUpdateDTO()
    this.blocked = true;
    this.platePreparationService.updateWashAndStainForMultipleArrays(updateDto).subscribe(
      result => {
        this.blocked = false;
        this._messagesService.addSuccessMessage({
          severity:'success', summary:"Wash And Stain Prep Completed Successfully",
          detail:result
        })
        this.updateMultiUpdateProcessStep(BeadChipProcessStep.HYBRIDIZATION, 2, BeadChipAction.WASH_AND_STAIN_PREP)
        this.closeMultiUpdatePopup(true);
        this.multiBeadChip = true;
      },
      error => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity:'error', summary:"Wash And Stain Prep Failed!!",
          detail:error.error
        });
        this.multiBeadChip = true;
      }
    )
  }

  getWashAndStainUpdateDTO(){
    let arrayList = []
    this.washAndStainTableSelectedRows.forEach(row => {
      arrayList = arrayList.concat(row.plateIDs)
    })
    let actionsData = {};
    WASH_AND_STAIN_PREP_ACTIONS.forEach( action => {
      if(action == BeadChipAction.WASH_AND_STAIN_PREP){
        actionsData[action] = {
          "liquidHandler":"",
          "chemicals":[]
        }
      }
      else{
        let actionName = WASH_AND_STAIN_PREP_ACTIONS_WITH_VARIABLE_NAMES[action]
        let chemicalName = WASH_AND_STAIN_PREP_ACTIONS_WITH_CHEMICAL_NAMES[action]
        let actionData = {
          "liquidHandler": this[actionName+"Equipment"],
          "chemicals": [{
            "chemical": chemicalName,
            "lots": this[actionName+"ChemicalList"]
          }]
        }
        actionsData[action] = actionData
      }
    })

    let updateDto = new WashAndStainPrepUpdateDTO();
    updateDto.labid = this.selectedLabId;
    updateDto.puid = this.puid;
    updateDto.actionsList = WASH_AND_STAIN_PREP_ACTIONS
    updateDto.actionsData = actionsData;
    updateDto.arrayList = arrayList;
    updateDto.processStep = BeadChipProcessStep.HYBRIDIZATION
    updateDto.status = BeadChipAction.WASH_AND_STAIN_PREP

    return updateDto;
  }

  validateLotValues(lotName){
    if(this[lotName+"Chemical"].trim() == ""){
      this._messagesService.addWarningMessage({
        severity:'warn', summary:"Chemical Lot Value is empty"
      })
      return;
    }
    this[lotName+"ChemicalList"].push(this[lotName+"Chemical"].trim())
    this[lotName+"Chemical"] = "";
  }

  deleteLotValue(lotName, index, highlightId){
    this[lotName+"ChemicalList"].splice(index,1)
    this.findAndHighlightElement(highlightId)
  }

  disableWashAndStainPrepButton(){
    if(this.washAndStainTableSelectedRows.length==0){
      return true
    }
    else if(this.stabilizationEquipment.trim() == "" || this.stabilizationChemicalList.length == 0 ){
      return true
    }
    else if(this.stain1Equipment.trim() == "" || this.stain1ChemicalList.length == 0 ){
      return true
    }
    else if(this.stain2Equipment.trim() == "" || this.stain2ChemicalList.length == 0 ){
      return true
    }
    else if(this.ligationEquipment.trim() == "" || this.ligationChemicalList.length == 0 ){
      return true
    }
    else if(this.holdBufferEquipment.trim() == "" || this.holdBufferChemicalList.length == 0 ){
      return true
    }
    else{
      return false
    }
  }

  createNewArraysForResultEvaluation(plateIDs: Array<string>){
    let data = new CreateNewArraysDTO();
    data.labID = this.selectedLabId;
    data.plateIDs = plateIDs;
    this.blocked = true;
    this.resultEvaluationService.createArrayFromSamplesData(data).subscribe(
      _result => {
        this.blocked = false;
        this._messagesService.addSuccessMessage({
          severity:'success', summary:"Success!!",
          detail:"Arrays data exported successfully."
        })
      },
      error => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity:'error', summary:"Error occured while exporting arrays",
          detail: error
        })
      }
    )
  }

  isMultiPlateOrDetailedWorkflow(){
    return (this.multiBeadChip || this.selectedProcessFlowConfig.detailedWorkflow)
  }

  downloadDataExportEvaluationReports(){
    this.blocked = true
    let request = {
      "arrayPlateID":this.selectedBeadChipPlate.plateID,
      "sampleData" : []
    }
    this.selectedBeadChipPlate.samples.forEach(sample => {
      request["sampleData"].push({
        "id" : sample._id,
        "sourcePlateID":sample.sourcePlateID,
        "position":sample.position
      })
    })
    this.announcementService.downloadDataExportEvaluationFile("metadata",request).subscribe(
      result => {
        this.blocked = false
        this._messagesService.addSuccessMessage({
          severity:'success',summary:'Downloading Data export evaluation files'
        })

        let blob = new Blob([result.fileContent], { type: result.fileContent.type });
        saveByFileSaver(blob,result.filename)
      },
      _error => {
        this.blocked = false
        this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Error',
            detail: "Error occured while generating metadata file"
          });
      }
    )
    this.announcementService.downloadDataExportEvaluationFile("snmf",request).subscribe(
      result => {
        this.blocked = false
        this._messagesService.addSuccessMessage({
          severity:'success',summary:'Downloading Data export evaluation files'
        })

        let blob = new Blob([result.fileContent], { type: result.fileContent.type });
        saveByFileSaver(blob,result.filename)
      },
      _error => {
        this.blocked = false
        this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Error',
            detail: "Error occured while generating SNMF file"
          });
      }
    )
  }

  getCSSClassForPanel(index: number){
    if(index == this.index){
      return 'selected';
    }else{
      return 'unselected';
    }
  }

  onTabChange(event) {
    this.index = event.index;
  }

}
